import img from './img';
import audio from './audio';
import gameData from './gameData.config.js';

var config = {
  author: 'TR',
  engine: 'puzzle',
  gameConfig: gameData,
  title: [
    {
      text: 'Do puzzles.',
      audio: 'games/page061_game0/audio/txt.mp3',
    },
  ],
  checkGameSound: {
    positive: 'games/page061_game0/audio/ok.mp3',
    negative: 'games/page061_game0/audio/no.mp3',
  },
  assets: {
    img: img || [],
    audio: audio || [],
    extendetJS: [],
    extendetStyle: [],
  },
};

// console.log( 'config', config );
export default config;
